'use client';

import { useWebsiteHref } from '@/hooks/use-website-href';
import { SidebarMenuItem, SidebarMenuButton, useSidebar } from '@ui/components/ui/sidebar';
import { MessageCircleQuestionMark } from 'lucide-react';
import { useTranslations } from 'next-intl';

export default function NavHelp() {
  const t = useTranslations('Navigation');
  const { toggleSidebar, isMobile } = useSidebar();
  const websiteUrl = useWebsiteHref();

  return (
    <SidebarMenuItem className="pb-2">
      <SidebarMenuButton
        tooltip={t('getHelp')}
        onClick={() => {
          window.open(`${websiteUrl}/contact`, '_blank');
          if (isMobile) toggleSidebar();
        }}
      >
        <MessageCircleQuestionMark />
        <span>{t('getHelp')}</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
